import { useState } from "react";
import ContextSwitcher from "@/components/ContextSwitcher";
import OwnContactForm, { ContactDetailsButton } from "@/components/OwnContactForm";
import BadgeIcon from "@/components/BadgeIcon";
import { useAuth } from "@/contexts/AuthContext";
import { displayName, roleBadges, scopeBadge } from "@/utils/sessionBadges";
import "./Profile.css";

const Profile = () => {
  const { user, roles, session, capabilities } = useAuth();
  const [contactOpen, setContactOpen] = useState(false);
  const badges = roleBadges(roles);
  const scope = scopeBadge(session?.acuityLearn?.schoolScope, session?.acuityLearn?.resolvedSchool);
  const name = displayName(user);
  const email = user?.email || "—";

  return (
    <div className="al-profile">
      <section className="al-account" aria-labelledby="al-account-title">
        <header className="al-account-header">
          <p id="al-account-title" className="al-account-eyebrow">
            Profile
          </p>
        </header>

        <div className="al-account-identity">
          <p className="al-account-name">{name}</p>
          <p className="al-account-email">{email}</p>
          {capabilities?.updateOwnContact ? (
            <ContactDetailsButton open={contactOpen} onClick={() => setContactOpen((open) => !open)} />
          ) : null}

          <div className="al-account-badges">
            {badges.length ? (
              badges.map((badge) => (
                <span key={badge.key} className="al-badge">
                  <BadgeIcon name={badge.icon} />
                  <span className="al-badge-label">{badge.label}</span>
                </span>
              ))
            ) : (
              <span className="al-badge">
                <BadgeIcon name="default" />
                <span className="al-badge-label">No role</span>
              </span>
            )}
            {scope ? (
              <span className="al-badge" title={scope.sub}>
                <BadgeIcon name={scope.icon} />
                <span className="al-badge-label">{scope.label}</span>
              </span>
            ) : null}
          </div>
        </div>

        <OwnContactForm open={contactOpen} />
        <ContextSwitcher variant="profile" />
      </section>
    </div>
  );
};

export default Profile;
